import { ICategory, IProduct, ICategoryOrProduct, isCategory } from "../models"

import { CategoryOperations } from "./category"
import { ProductOperations } from "./product"

export type CategoryOrProductOperations = {
  delete(categoryOrProduct: ICategoryOrProduct): void
  update<TFieldKey extends keyof ICategoryOrProduct>(
    categoryOrProduct: ICategoryOrProduct,
    fieldName: TFieldKey,
    value: (ICategory & IProduct)[TFieldKey],
    options?: { collapse?: boolean },
  ): void
}

export default (category: CategoryOperations, product: ProductOperations): CategoryOrProductOperations => ({
  delete(categoryOrProduct) {
    if (isCategory(categoryOrProduct)) {
      category.delete(categoryOrProduct)
    } else {
      product.delete(categoryOrProduct)
    }
  },

  update(categoryOrProduct, fieldName, value, options) {
    if (isCategory(categoryOrProduct)) {
      category.update(categoryOrProduct.id, fieldName, value, options)
    } else {
      product.update(categoryOrProduct.id, fieldName, value, options)
    }
  },
})
